import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private isLoading : boolean = false;
  load : boolean = false;
  spinner = new BehaviorSubject<string>('');

  constructor() { }

  getSpinnerObserver() : Observable<string>{
    return this.spinner.asObservable();
  }

  requestStarted(){
    if(!this.isLoading){
      this.isLoading = true;
      this.spinner.next('start');
    }
  }

  requestEnded(){
    if(this.isLoading){
      this.isLoading = false;
      this.spinner.next('stop');
    }
  }

  resetSpinner(){
    this.isLoading = false;
    this.spinner.next('stop');
  }

  // startLoading(){
  //   this.load = true;
  // }

  // finishLoading(){
  //   this.load = false;
  // }

}
